/** Display helpers for the Store performance surface. These are counts and a
 * percentage; there is no currency on this surface. */

/**
 * Format a conversion RATE (a fraction, e.g. 0.05) as a percentage to 1 dp
 * (-> "5.0%"). A null rate (no matured clicks yet) renders as "n/a" so a fresh
 * store reads as "still maturing", never as a 0% leak.
 */
export const formatRate = (rate: number | null): string =>
  rate == null ? 'n/a' : `${(rate * 100).toFixed(1)}%`;
